import { Card, CardBody, CardHeader, CardHeading, FormattedDate } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ValueView } from "../../contactUpdateInquiries/details/ValueView";
import { ContactUpdateInquiryDetailsResource } from "../../shared/types/contactUpdateInquiry";

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(4)};
`;

const LongValueView = styled(ValueView)`
	grid-column: 1 / -1;
`;

interface Props {
	contactUpdateInquiry: ContactUpdateInquiryDetailsResource;
}

export const ContactUpdateInquiryBaseData: FC<Props> = ({ contactUpdateInquiry }) => {
	const { t } = useTranslation();

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Contact update campaign")}</CardHeading>
			</CardHeader>
			<StyledCardBody>
				<ValueView label={t("Name")} value={contactUpdateInquiry.name} />
				<ValueView label={t("Date")} value={<FormattedDate date={contactUpdateInquiry.startDate} />} />
				<ValueView label={t("Contact filter")} value={contactUpdateInquiry.contactFilter.name} />
				<ValueView label={t("Due date")} value={<FormattedDate date={contactUpdateInquiry.dueDate} />} />
				<LongValueView
					label={t("Additional data fields")}
					value={contactUpdateInquiry.additionalDataFields.map((d) => d.label).join(", ")}
				/>
			</StyledCardBody>
		</Card>
	);
};
